import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "@material-ui/core";

import {
  getDocumentacionPracticaSolicitud,
  getPracticas,
  postPracticas,
  setActiveStep,
  setShowForm,
} from "../../../actions/autorizaciones/Autorizaciones";
import { getZonasEfector } from "../../../actions/contrataciones/contratacionesCartilla";

import {
  AUTORIZACIONES_PRACTICAS_ESTADOS,
  PRACTICA_INSUMOS_AUTORIZACIONES,
  PRACTICA_APERTURA_DENUNCIA_INTERNACION,
  STEPPER_AUTORIZACIONES,
  TIPOS_AUTORIZACIONES,
  PRACTICA_APERTURA_INTERNACION_DOMICILIARIA,
  PRACTICA_CIERRE_DENUNCIA_INTERNACION,
  PRACTICA_CIERRE_INTERNACION_DOMICILIARIA,
} from "../../../utils/constants";

import { AutorizacionesCard } from "../UI/AutorizacionesCard";
import { AutorizacionesAddPractica } from "./AutorizacionesAddPractica";
import { AutorizacionesPractica } from "./AutorizacionesPractica";
import { startAlerta } from "../../../actions/ui/alertas";
import { Redirect } from "react-router-dom";

export const AutorizacionesPracticas = (props) => {
  const dispatch = useDispatch();

  const { practicas = [], solicitudSeleccionada = {} } = useSelector(
    (state) => state.autorizaciones
  );
  const { zonas = [] } = useSelector((state) => state.contratacionesCartilla);

  const [redirect, setRedirect] = useState(false);

  if (zonas?.length === 0) {
    dispatch(getZonasEfector());
  }

  const practicaDefault = (idTipoSolicitud) => {
    if (idTipoSolicitud === TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS)
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        cant: 1,
        idCodNom: PRACTICA_INSUMOS_AUTORIZACIONES.ID_COD_NOM,
        practica: {
          codNom: PRACTICA_INSUMOS_AUTORIZACIONES.COD_NOM,
          desNom: PRACTICA_INSUMOS_AUTORIZACIONES.DES_NOM,
        },
        idEfectorFacturacion: null,
        idCartillaPrestador: null,        //EfectorInstitucional
        idPrestador: null,                //EfectorProfesional
        idPrescriptor: null,
        idTipoSolicitud: solicitudSeleccionada.idTipoSolicitud,
        idEstadoPractica: AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE,
      };
    else if (idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION)
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        cant: 1,
        idCodNom: PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM,
        practica: {
          codNom: PRACTICA_APERTURA_DENUNCIA_INTERNACION.COD_NOM,
          desNom: PRACTICA_APERTURA_DENUNCIA_INTERNACION.DES_NOM,
        },
        idEfectorFacturacion: null,
        idCartillaPrestador: null,        //EfectorInstitucional
        idPrestador: null,                //EfectorProfesional
        idPrescriptor: null,
        idTipoSolicitud: solicitudSeleccionada.idTipoSolicitud,
        idEstadoPractica: AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE,
      };
    else if (idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        cant: 1,
        idCodNom: PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM,
        practica: {
          codNom: PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.COD_NOM,
          desNom: PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.DES_NOM,
        },
        idEfectorFacturacion: null,
        idCartillaPrestador: null,        //EfectorInstitucional
        idPrestador: null,                //EfectorProfesional
        idPrescriptor: null,
        idTipoSolicitud: solicitudSeleccionada.idTipoSolicitud,
        idEstadoPractica: AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE,
      };
    else
      return {};
  }

  useEffect(() => {
    const practica = practicaDefault(solicitudSeleccionada.idTipoSolicitud);
    const agregaPracticaDefault = (solicitudSeleccionada.idTipoSolicitud ===
      TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS ||
      solicitudSeleccionada.idTipoSolicitud ===
      TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||
      solicitudSeleccionada.idTipoSolicitud ===
      TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA) ? true : false;
    dispatch(getPracticas(solicitudSeleccionada.idTipoSolicitud, agregaPracticaDefault, practica));
  }, [dispatch]);

  useEffect(() => {
    if (solicitudSeleccionada.idSolicitud) dispatch(getDocumentacionPracticaSolicitud(solicitudSeleccionada.idSolicitud));
  }, [solicitudSeleccionada.idSolicitud]);

  const avanzarPantalla = () => {
    dispatch(setActiveStep(STEPPER_AUTORIZACIONES.CONFIRMACION));
  };

  const onClickSiguienteHandler = () => {
    let faltaEfectorInstitucional = false;
    let faltanPeriodosDenunciaInterDom = false;
    let faltaEfectorInstitucionalDenunciaIntDomiciliaria = false;
    let index = 0;

    while (index < practicas.length) {
      if (!faltaEfectorInstitucional)
        faltaEfectorInstitucional = !practicas[index].idCartillaPrestador;
      if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
        practicas[index].idCodNom !== PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM) {
        if (!faltaEfectorInstitucionalDenunciaIntDomiciliaria)
          faltaEfectorInstitucionalDenunciaIntDomiciliaria = !practicas[index].idEfectorFacturacion &&
            practicas[index].idCodNom !== PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM;
        if (!faltanPeriodosDenunciaInterDom)
          faltanPeriodosDenunciaInterDom = practicas[index].periodos?.length === 0;
      }
      index++;
    }

    if (
      (faltaEfectorInstitucional &&
        solicitudSeleccionada.idTipoSolicitud !==
        TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS &&
        solicitudSeleccionada.idTipoSolicitud !==
        TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA) ||
      (faltaEfectorInstitucionalDenunciaIntDomiciliaria &&
        solicitudSeleccionada.idTipoSolicitud ===
        TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
    ) {
      dispatch(
        startAlerta(
          `Los Efectores Institucionales no pueden quedar vacio.`,
          "error"
        )
      );
    } else if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
      faltanPeriodosDenunciaInterDom) {
      dispatch(
        startAlerta(
          `Todas las prácticas deben tener periodos cargados.`,
          "error",
          "Error"
        )
      );
    } else {
      const errContacto = practicas.map(
        (pr) => pr.emailEfectorIError || pr.celularEfectorIError
      );
      if (errContacto.filter((err) => err).length > 0) {
        dispatch(
          startAlerta(
            `Verifique los datos de contacto de los Efectores Institucionales.`,
            "error"
          )
        );
      } else {
        //CUANDO ES DENUNCIA_INTERNACION_DOMICILIARIA SETEO EL IdEfectorFacturacion de la practica de apertura
        let idEfectorFDeunciaIntDom = null;
        if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA && practicas.length > 1)
          idEfectorFDeunciaIntDom = practicas[1].idEfectorFacturacion;

        const practicasFormateadas = practicas.map((practica) => {
          const materialesFormateados = practica.materiales?.map((material) => {
            return {
              idMaterial: material.idMaterial,
              cant: material.cantidad,
              idEstadoMaterial: material.idEstadoMaterial,
              recuperoSur: material.recuperoSur,
              disponible: material.disponible,
            };
          });

          const periodosFormateados = practica.periodos?.map((periodo) => {
            return {
              idCodNom: periodo.idCodNom,
              periodo: periodo.periodo,
              cant: periodo.cant,
              idEstadoPeriodoPractica: periodo.idEstadoPeriodoPractica,
            };
          });

          return {
            idSolicitud: practica.idSolicitud,
            idCodNom: practica.idCodNom,
            cant: practica.cant,
            materiales: materialesFormateados ? materialesFormateados : [],
            periodos: periodosFormateados ? periodosFormateados : [],
            copiaEfectorInstitucional: practica.copiaEfectorInstitucional,
            idEfectorFacturacion: (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
              practica.idCodNom === PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM)
              ? idEfectorFDeunciaIntDom
              : practica.idEfectorFacturacion,
            idCartillaPrestador: practica.idCartillaPrestador,
            idPrestador: practica.idPrestador,
            idPrescriptor: practica.idPrescriptor,
            idEstadoPractica: practica.idEstadoPractica,
            celularEfectorI: practica.celularEfectorI,
            emailEfectorI: practica.emailEfectorI,
            idTipoSolicitud: solicitudSeleccionada.idTipoSolicitud,
          };
        });

        if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||
          solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
          dispatch(
            postPracticas({ practicas: practicasFormateadas }, null, null, null, true, solicitudSeleccionada.idSolicitud, setRedirect)
          );
        else
          dispatch(
            postPracticas({ practicas: practicasFormateadas }, avanzarPantalla)
          );
      }
    }
  };

  return (
    <AutorizacionesCard width={"75%"}>
      {(solicitudSeleccionada.idTipoSolicitud ===
        TIPOS_AUTORIZACIONES.PRACTICAS ||
        solicitudSeleccionada.idTipoSolicitud ===
        TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION ||
        solicitudSeleccionada.idTipoSolicitud ===
        TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA ||
        solicitudSeleccionada.idTipoSolicitud ===
        TIPOS_AUTORIZACIONES.OXIGENO
      ) && (
          <AutorizacionesAddPractica idTipoSolicitud={solicitudSeleccionada.idTipoSolicitud} />
      )}

      {practicas//.filter(s => s.idCodNom !== PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM)
        .filter(s => s.idCodNom !== PRACTICA_CIERRE_DENUNCIA_INTERNACION.ID_COD_NOM)
        .filter(s => s.idCodNom !== PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM)
        .filter(s => s.idCodNom !== PRACTICA_CIERRE_INTERNACION_DOMICILIARIA.ID_COD_NOM)
        .map((practica, index) => {
          return (
            <AutorizacionesPractica
              key={index}
              practica={practica}
              idTipoSolicitud={solicitudSeleccionada.idTipoSolicitud}
              conInternacion={solicitudSeleccionada.conInternacion}
              permisoIngresoInterDom={props.permisoIngresoInterDom}
            />
          );
        })}

      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            dispatch(setActiveStep(STEPPER_AUTORIZACIONES.DETALLES_ORDEN));
            dispatch(setShowForm(false));
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
        >
          Siguiente
        </Button>
      </div>
      {redirect && (
        <Redirect
          to={{
            pathname: "/autorizaciones",
          }}
        />
      )}
    </AutorizacionesCard>
  );
};
